import scoreTimelines from "./score-timelines.json" with { type: "json" };
const finalsScoreEvents = scoreTimelines.games["0042500404"]
    .events;
const regularScoreEvents = scoreTimelines.games["0022500641"]
    .events;
export const nbaVisualFixtures = {
    finalsHalftimeInsight: {
        type: "insight-receipt",
        label: "NBA box score · halftime",
        sourceRefs: ["NBA box score 2f237b43f2c7", "Getty 2280981198"],
        subject: "San Antonio from three",
        made: 11,
        attempted: 16,
        percentageLabel: "69%",
        percentageCaption: "FROM THREE",
        marginLabel: "+27",
        marginCaption: "AT HALF"
    },
    finalsComebackFive: {
        type: "lineup-stint",
        label: "NBA lineup box · Game 4",
        sourceRefs: ["NBA lineup 769c74d81f3e"],
        teamAbbreviation: "NYK",
        players: [
            "Karl-Anthony Towns",
            "OG Anunoby",
            "Josh Hart",
            "Jalen Brunson",
            "Jose Alvarado"
        ],
        minutes: 7,
        points: 22,
        fieldGoals: "8/11",
        threePointers: "4/4",
        assists: 6,
        plusMinus: 15
    },
    finalsRobinsonImpact: {
        type: "impact-receipt",
        label: "NBA hustle events · through Q3",
        sourceRefs: ["NBA hustle 9e32d3c639c1", "NBA hustle 9293d748e511"],
        player: "Mitchell Robinson",
        actionLabel: "screen assists",
        totalActions: 3,
        totalPointsCreated: 8,
        events: [
            { clockLabel: "Q1 · 8:52", pointsCreated: 3 },
            { clockLabel: "Q3 · 3:52", pointsCreated: 2 },
            { clockLabel: "Q3 · 0:53", pointsCreated: 3 }
        ]
    },
    finalsWinningSequence: {
        type: "court-moment",
        label: "NBA play-by-play · final 40 seconds",
        sourceRefs: ["NBA play-by-play 18a34c885b0b", "NBA events 8e8797ab5878"],
        basketSide: "left",
        heroShotId: "og-tip",
        legend: {
            missed: "Brunson miss",
            made: "Anunoby make"
        },
        phaseLabel: "FINAL 40 SECONDS",
        sequenceLabel: "Anunoby protected one rim, then owned the other.",
        accessibleSummary: "Jalen Brunson missed with 39.2 seconds left. Stephon Castle put San Antonio ahead at 30.3, then Brunson missed again at 16.1. OG Anunoby blocked De'Aaron Fox at 11.1. Brunson missed a third time at 4.4, and Anunoby tipped in the winner with 2.1 seconds remaining.",
        sequenceEvents: [
            { clockLabel: "39.2", label: "Brunson misses", tone: "possession" },
            { clockLabel: "30.3", label: "Castle retakes lead", tone: "score" },
            { clockLabel: "16.1", label: "Brunson misses again", tone: "possession" },
            { clockLabel: "11.1", label: "Anunoby blocks Fox", tone: "defense" },
            { clockLabel: "4.4", label: "Brunson's third miss", tone: "possession" },
            { clockLabel: "2.1", label: "Anunoby wins it", tone: "score" }
        ],
        shots: [
            {
                id: "brunson-39",
                player: "Jalen Brunson",
                result: "missed",
                xPercent: 8.1,
                yPercent: 73.53,
                clockLabel: "39.2"
            },
            {
                id: "brunson-16",
                player: "Jalen Brunson",
                result: "missed",
                xPercent: 7.7,
                yPercent: 39.71,
                clockLabel: "16.1"
            },
            {
                id: "brunson-4",
                player: "Jalen Brunson",
                result: "missed",
                xPercent: 37.27,
                yPercent: 33.58,
                clockLabel: "4.4"
            },
            {
                id: "og-tip",
                player: "OG Anunoby",
                result: "made",
                xPercent: 5.59,
                yPercent: 50,
                clockLabel: "2.1",
                annotation: "WINNING TIP"
            }
        ]
    },
    finalsComebackFlow: {
        type: "game-flow",
        label: "NBA play-by-play · official scoring timeline",
        sourceRefs: ["NBA play-by-play 18a34c885b0b", "NBA game 0042500404"],
        headline: "From 29 down to one point ahead",
        accessibleSummary: "New York trailed by 29 in the third quarter and won by one.",
        points: finalsScoreEvents,
        periodLengthSeconds: 720,
        perspective: "home",
        awayAbbreviation: "SAS",
        homeAbbreviation: "NYK",
        awayColor: "#C4CED4",
        homeColor: "#F58426",
        annotations: [
            {
                period: 3,
                clockSeconds: 580,
                margin: -29,
                scoreLabel: "SAS 81–52",
                label: "29 DOWN"
            },
            {
                period: 4,
                clockSeconds: 82,
                margin: 1,
                scoreLabel: "NYK 105–104",
                label: "FIRST LEAD"
            },
            {
                period: 4,
                clockSeconds: 0,
                margin: 1,
                scoreLabel: "NYK 107–106",
                label: "FINAL"
            }
        ]
    },
    finalsComebackApiInsight: {
        type: "api-insight",
        label: "NBA API Insight",
        sourceRefs: [
            "NBA insight ded8b3743891",
            "NBA box score 2f237b43f2c7",
            "NBA play-by-play 18a34c885b0b"
        ],
        subject: "The comeback in numbers",
        claim: "New York erased 29 points and won by one after a 32–16 fourth quarter.",
        facts: [
            { value: "29", label: "DEFICIT" },
            { value: "32–16", label: "FOURTH" },
            { value: "107–106", label: "FINAL" }
        ]
    },
    regularPullUpProfile: {
        type: "tracking-shot-profile",
        label: "NBA tracking shots · full game",
        sourceRefs: ["NBA tracking shots 0e8cc2f76521"],
        metricLabel: "Pull-up field goals",
        players: [
            {
                player: "Shai Gilgeous-Alexander",
                teamAbbreviation: "OKC",
                made: 7,
                attempted: 16,
                percentageLabel: "44%",
                color: "#F05133"
            },
            {
                player: "Andrew Nembhard",
                teamAbbreviation: "IND",
                made: 5,
                attempted: 8,
                percentageLabel: "63%",
                color: "#FDBB30"
            }
        ]
    },
    regularOnePossessionFlow: {
        type: "game-flow",
        label: "NBA play-by-play · official scoring timeline",
        sourceRefs: ["NBA play-by-play 4b26b9387408", "NBA game 0022500641"],
        headline: "Seventeen points became one possession",
        accessibleSummary: "Indiana led by 17 before Oklahoma City cut the game to one point, then Indiana won by three.",
        points: regularScoreEvents,
        periodLengthSeconds: 720,
        perspective: "away",
        awayAbbreviation: "IND",
        homeAbbreviation: "OKC",
        awayColor: "#FDBB30",
        homeColor: "#F05133",
        annotations: [
            {
                period: 2,
                clockSeconds: 543,
                margin: 17,
                scoreLabel: "IND 47–30",
                label: "17-POINT LEAD"
            },
            {
                period: 4,
                clockSeconds: 24.3,
                margin: 1,
                scoreLabel: "IND 113–112",
                label: "ONE POINT"
            },
            {
                period: 4,
                clockSeconds: 0,
                margin: 3,
                scoreLabel: "IND 117–114",
                label: "FINAL"
            }
        ]
    },
    regularSgaApiInsight: {
        type: "api-insight",
        label: "NBA API Insight",
        sourceRefs: [
            "NBA insight 62e1d9160672",
            "NBA box score 5261fe267ff3",
            "NBA play-by-play 4b26b9387408"
        ],
        subject: "Forty-seven was not enough",
        claim: "Gilgeous-Alexander scored 47, but Indiana answered with 53 combined from Nembhard and Walker and won by three.",
        facts: [
            { value: "47", label: "SGA PTS" },
            { value: "53", label: "IND DUO" },
            { value: "117–114", label: "FINAL" }
        ]
    },
    regularSecondUnitFive: {
        type: "lineup-stint",
        label: "NBA lineup box · Pacers at Thunder",
        sourceRefs: ["NBA lineup b88547affef5"],
        teamAbbreviation: "IND",
        players: [
            "Andrew Nembhard",
            "Aaron Nesmith",
            "Micah Potter",
            "Jarace Walker",
            "Ben Sheppard"
        ],
        minutes: 2.5,
        points: 12,
        fieldGoals: "5/5",
        threePointers: "2/2",
        assists: 5,
        plusMinus: 6
    },
    regularPotterImpact: {
        type: "impact-receipt",
        label: "NBA hustle events · full game",
        sourceRefs: ["NBA hustle c2946e0322b2", "NBA hustle c7938140c5d5"],
        player: "Micah Potter",
        actionLabel: "screen assists",
        totalActions: 5,
        totalPointsCreated: 12,
        events: [
            { clockLabel: "Q1 · 1:22", pointsCreated: 2 },
            { clockLabel: "Q2 · 0:50", pointsCreated: 2 },
            { clockLabel: "Q3 · 6:10", pointsCreated: 3 },
            { clockLabel: "Q4 · 8:28", pointsCreated: 2 },
            { clockLabel: "Q4 · 2:13", pointsCreated: 3 }
        ]
    },
    summerClosingFive: {
        type: "lineup-stint",
        label: "NBA lineup box · Summer League",
        sourceRefs: ["NBA lineup 1cef3db10f71"],
        teamAbbreviation: "LAL",
        players: [
            "Arthur Kaluma",
            "Cameron Carr",
            "Peter Suder",
            "AK Okereke",
            "William Kyle III"
        ],
        minutes: 5.1,
        points: 23,
        fieldGoals: "8/10",
        threePointers: "4/6",
        assists: 7,
        plusMinus: 17
    }
};
